import { Grid, styled } from '@mui/material'

export const StyledGridItem = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}))
